import { Injectable, ɵɵdefineInjectable, Component, NgModule, Pipe, Inject, ɵɵinject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { FormGroup, FormArray } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firma-base.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FirmaBaseService {
    constructor() { }
}
FirmaBaseService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FirmaBaseService.ctorParameters = () => [];
/** @nocollapse */ FirmaBaseService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FirmaBaseService_Factory() { return new FirmaBaseService(); }, token: FirmaBaseService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firma-base.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FirmaBaseComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
FirmaBaseComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-firma-base',
                template: `
    <p>
      firma-base works!
    </p>
  `
            }] }
];
/** @nocollapse */
FirmaBaseComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firma-base.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FirmaBaseModule {
}
FirmaBaseModule.decorators = [
    { type: NgModule, args: [{
                declarations: [FirmaBaseComponent],
                imports: [],
                exports: [FirmaBaseComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/application/custom-pipes/safe-html.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafeHtmlPipe {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} html
     * @return {?}
     */
    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
SafeHtmlPipe.decorators = [
    { type: Pipe, args: [{
                name: 'safeHtml'
            },] }
];
/** @nocollapse */
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SafeHtmlPipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/application/custom-pipes/custom-pipes.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomPipesModule {
}
CustomPipesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SafeHtmlPipe],
                imports: [
                    CommonModule
                ],
                exports: [
                    SafeHtmlPipe
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/application/selectables/option-item.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function OptionItem() { }
if (false) {
    /** @type {?} */
    OptionItem.prototype.id;
    /** @type {?} */
    OptionItem.prototype.descripcion;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/crea-solicitud-firma.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CreaSolicitudFirmaService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.solicitudFirmaUrl = '';
        this.solicitudFirmaUrl = apiUrl + 'solicitud-firma';
    }
    /**
     * @param {?} data
     * @return {?}
     */
    __invoke(data) {
        return this.httpClient.post(this.solicitudFirmaUrl + '/store', data)
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        response => (/** @type {?} */ (response)))));
    }
}
CreaSolicitudFirmaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CreaSolicitudFirmaService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ CreaSolicitudFirmaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CreaSolicitudFirmaService_Factory() { return new CreaSolicitudFirmaService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: CreaSolicitudFirmaService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CreaSolicitudFirmaService.prototype.solicitudFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    CreaSolicitudFirmaService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    CreaSolicitudFirmaService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/get-solicitudes-pendientes-firmante.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GetSolicitudesPendientesFirmanteService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.solicitudFirmaUrl = '';
        this.solicitudFirmaUrl = apiUrl + 'solicitud-firma';
    }
    /**
     * @param {?} data
     * @return {?}
     */
    __invoke(data) {
        return this.httpClient.post(this.solicitudFirmaUrl + '/get-pendientes-firmante', data)
            .pipe(map((/**
         * @param {?} solicitudFirma
         * @return {?}
         */
        solicitudFirma => (/** @type {?} */ (solicitudFirma)))));
    }
}
GetSolicitudesPendientesFirmanteService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
GetSolicitudesPendientesFirmanteService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ GetSolicitudesPendientesFirmanteService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GetSolicitudesPendientesFirmanteService_Factory() { return new GetSolicitudesPendientesFirmanteService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: GetSolicitudesPendientesFirmanteService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    GetSolicitudesPendientesFirmanteService.prototype.solicitudFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    GetSolicitudesPendientesFirmanteService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    GetSolicitudesPendientesFirmanteService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/registra-firma.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RegistraFirmaService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.registroFirmaUrl = '';
        this.registroFirmaUrl = apiUrl + 'registro-firma';
    }
    /**
     * @param {?} data
     * @return {?}
     */
    __invoke(data) {
        return this.httpClient.post(this.registroFirmaUrl, data)
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        response => (/** @type {?} */ (response)))));
    }
}
RegistraFirmaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RegistraFirmaService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ RegistraFirmaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RegistraFirmaService_Factory() { return new RegistraFirmaService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: RegistraFirmaService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RegistraFirmaService.prototype.registroFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    RegistraFirmaService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    RegistraFirmaService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/search-solicitudes-firma.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SearchSolicitudesFirmaService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.solicitudFirmaUrl = '';
        this.solicitudFirmaUrl = apiUrl + 'solicitud-firma';
    }
    /**
     * @param {?} data
     * @return {?}
     */
    __invoke(data) {
        return this.httpClient.post(this.solicitudFirmaUrl + '/search', data)
            .pipe(map((/**
         * @param {?} solicitudFirma
         * @return {?}
         */
        solicitudFirma => (/** @type {?} */ (solicitudFirma)))));
    }
}
SearchSolicitudesFirmaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SearchSolicitudesFirmaService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ SearchSolicitudesFirmaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SearchSolicitudesFirmaService_Factory() { return new SearchSolicitudesFirmaService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: SearchSolicitudesFirmaService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    SearchSolicitudesFirmaService.prototype.solicitudFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    SearchSolicitudesFirmaService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    SearchSolicitudesFirmaService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/search-solicitudes-firma-pendientes.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SearchSolicitudesFirmaPendientesService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.solicitudFirmaUrl = '';
        this.solicitudFirmaUrl = apiUrl + 'solicitud-firma';
    }
    /**
     * @param {?} data
     * @return {?}
     */
    __invoke(data) {
        return this.httpClient.post(this.solicitudFirmaUrl + '/search-pendientes', data)
            .pipe(map((/**
         * @param {?} solicitudFirma
         * @return {?}
         */
        solicitudFirma => (/** @type {?} */ (solicitudFirma)))));
    }
}
SearchSolicitudesFirmaPendientesService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SearchSolicitudesFirmaPendientesService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ SearchSolicitudesFirmaPendientesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SearchSolicitudesFirmaPendientesService_Factory() { return new SearchSolicitudesFirmaPendientesService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: SearchSolicitudesFirmaPendientesService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    SearchSolicitudesFirmaPendientesService.prototype.solicitudFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    SearchSolicitudesFirmaPendientesService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    SearchSolicitudesFirmaPendientesService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/solicitud-firma.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SolicitudFirmaService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.solicitudFirmaUrl = '';
        this.solicitudFirmaUrl = apiUrl + 'solicitud-firma';
    }
    /**
     * @param {?} idSolicitud
     * @return {?}
     */
    __invoke(idSolicitud) {
        return this.httpClient.get(this.solicitudFirmaUrl + '/' + idSolicitud)
            .pipe(map((/**
         * @param {?} solicitudFirma
         * @return {?}
         */
        solicitudFirma => (/** @type {?} */ (solicitudFirma)))));
    }
}
SolicitudFirmaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SolicitudFirmaService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ SolicitudFirmaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SolicitudFirmaService_Factory() { return new SolicitudFirmaService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: SolicitudFirmaService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    SolicitudFirmaService.prototype.solicitudFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    SolicitudFirmaService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    SolicitudFirmaService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/solicitud-firma.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SolicitudFirma() { }
if (false) {
    /** @type {?} */
    SolicitudFirma.prototype.fecha;
    /** @type {?} */
    SolicitudFirma.prototype.id;
    /** @type {?} */
    SolicitudFirma.prototype.uuid;
    /** @type {?} */
    SolicitudFirma.prototype.codigo_centro;
    /** @type {?} */
    SolicitudFirma.prototype.contenido_solicitud;
    /** @type {?} */
    SolicitudFirma.prototype.nombre_firmante;
    /** @type {?} */
    SolicitudFirma.prototype.apellidos_firmante;
    /** @type {?} */
    SolicitudFirma.prototype.dni_firmante;
    /** @type {?} */
    SolicitudFirma.prototype.email_firmante;
    /** @type {?|undefined} */
    SolicitudFirma.prototype.nombre_tutor_legal;
    /** @type {?} */
    SolicitudFirma.prototype.informacion_adicional;
    /** @type {?} */
    SolicitudFirma.prototype.informacion_adicional_resumida;
    /** @type {?} */
    SolicitudFirma.prototype.tipo_solicitud;
    /** @type {?} */
    SolicitudFirma.prototype.estado;
    /** @type {?|undefined} */
    SolicitudFirma.prototype.nombre_estado;
    /** @type {?} */
    SolicitudFirma.prototype.api_key;
    /** @type {?|undefined} */
    SolicitudFirma.prototype.ruta_fichero_original;
    /** @type {?} */
    SolicitudFirma.prototype.comentario_firmante;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/shared/modules/solicitud-firma/list-estados-solicitud-firma.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListEstadosSolicitudFirmaService {
    /**
     * @param {?} httpClient
     * @param {?} apiUrl
     */
    constructor(httpClient, apiUrl) {
        this.httpClient = httpClient;
        this.apiUrl = apiUrl;
        this.solicitudFirmaUrl = '';
        this.solicitudFirmaUrl = apiUrl + 'solicitud-firma';
    }
    /**
     * @return {?}
     */
    __invoke() {
        return this.httpClient.get(this.solicitudFirmaUrl + '/estados/list')
            .pipe(map((/**
         * @param {?} estados
         * @return {?}
         */
        estados => (/** @type {?} */ (estados)))));
    }
}
ListEstadosSolicitudFirmaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ListEstadosSolicitudFirmaService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
];
/** @nocollapse */ ListEstadosSolicitudFirmaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ListEstadosSolicitudFirmaService_Factory() { return new ListEstadosSolicitudFirmaService(ɵɵinject(HttpClient), ɵɵinject("apiUrl")); }, token: ListEstadosSolicitudFirmaService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ListEstadosSolicitudFirmaService.prototype.solicitudFirmaUrl;
    /**
     * @type {?}
     * @private
     */
    ListEstadosSolicitudFirmaService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    ListEstadosSolicitudFirmaService.prototype.apiUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/services/authentication/login.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoginService {
    /**
     * @param {?} http
     * @param {?} authUrl
     */
    constructor(http, authUrl) {
        this.http = http;
        this.authUrl = authUrl;
        this.loginUrl = '';
        this.loginUrl = authUrl + '/login';
    }
    /**
     * @param {?} authData
     * @return {?}
     */
    __invoke(authData) {
        return this.http.post(this.authUrl + '/login', authData)
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        (response) => (/** @type {?} */ (response)))));
    }
}
LoginService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LoginService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: ['authUrl',] }] }
];
/** @nocollapse */ LoginService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(ɵɵinject(HttpClient), ɵɵinject("authUrl")); }, token: LoginService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.loginUrl;
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.authUrl;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/services/configuracion/get-custom-theme.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GetCustomThemeService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * @param {?} userUrlBase
     * @return {?}
     */
    __invoke(userUrlBase) {
        return this.httpClient.get(userUrlBase + '/publico/custom-theme-app-firma')
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        (response) => (/** @type {?} */ (response)))));
    }
}
GetCustomThemeService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
GetCustomThemeService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ GetCustomThemeService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GetCustomThemeService_Factory() { return new GetCustomThemeService(ɵɵinject(HttpClient)); }, token: GetCustomThemeService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    GetCustomThemeService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/services/validation/validation.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidationService {
    constructor() { }
    /**
     * @param {?} formGroup
     * @param {?} validationMessages
     * @return {?}
     */
    validateForm(formGroup, validationMessages) {
        for (const validationMessage in validationMessages) {
            /** @type {?} */
            const splitedMessage = validationMessage.split('.');
            if (splitedMessage.length > 1) {
                this.getValidationControlFromArray(formGroup, validationMessage).setErrors(validationMessages[validationMessage]);
            }
            else {
                formGroup.controls[validationMessage].setErrors(validationMessages[validationMessage]);
            }
        }
    }
    /**
     * @private
     * @param {?} formGroup
     * @param {?} validationMessage
     * @return {?}
     */
    getValidationControlFromArray(formGroup, validationMessage) {
        /** @type {?} */
        const splitedMessage = validationMessage.split('.');
        /** @type {?} */
        const abstractControl = (/** @type {?} */ (formGroup.get(splitedMessage[0])));
        if (abstractControl instanceof FormGroup) {
            return (/** @type {?} */ ((abstractControl).get(splitedMessage[1])));
        }
        if (abstractControl instanceof FormArray) {
            return (/** @type {?} */ ((abstractControl.at(Number(splitedMessage[1]))).get(splitedMessage[2])));
        }
    }
}
ValidationService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ValidationService.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/interfaces/authentication/logged-user.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function LoggedUser() { }
if (false) {
    /** @type {?} */
    LoggedUser.prototype.id;
    /** @type {?} */
    LoggedUser.prototype.name;
    /** @type {?} */
    LoggedUser.prototype.email;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/interfaces/configuracion/custom-theme.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CustomTheme() { }
if (false) {
    /** @type {?} */
    CustomTheme.prototype.custom_mensaje_firma;
    /** @type {?|undefined} */
    CustomTheme.prototype.custom_logo;
    /** @type {?|undefined} */
    CustomTheme.prototype.custom_css;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/env-url.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EnvUrlModule {
    /**
     * @param {?} apiUrl
     * @param {?} authUrl
     * @param {?} guestUrl
     * @param {?} baseUrl
     * @param {?} auditoriaUrl
     * @return {?}
     */
    static forRoot(apiUrl, authUrl, guestUrl, baseUrl, auditoriaUrl) {
        return {
            ngModule: EnvUrlModule,
            providers: [
                {
                    provide: 'apiUrl',
                    useValue: apiUrl
                },
                {
                    provide: 'guestUrl',
                    useValue: guestUrl
                },
                {
                    provide: 'authUrl',
                    useValue: authUrl
                },
                {
                    provide: 'baseUrl',
                    useValue: baseUrl
                },
                {
                    provide: 'auditoriaUrl',
                    useValue: auditoriaUrl
                }
            ]
        };
    }
}
EnvUrlModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [
                    CommonModule
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: firma-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CreaSolicitudFirmaService, CustomPipesModule, EnvUrlModule, FirmaBaseComponent, FirmaBaseModule, FirmaBaseService, GetCustomThemeService, GetSolicitudesPendientesFirmanteService, ListEstadosSolicitudFirmaService, LoginService, RegistraFirmaService, SearchSolicitudesFirmaPendientesService, SearchSolicitudesFirmaService, SolicitudFirmaService, ValidationService, SafeHtmlPipe as ɵa };
//# sourceMappingURL=firma-base.js.map
